(()=>{
  if(window.__imperialSelectItemBound)return;
  window.__imperialSelectItemBound=true;

  const toNumber=value=>{
    if(value==null||String(value).trim()==='')return NaN;
    return Number(value);
  };

  const itemFromCard=card=>{
    const itemId=card.dataset.itemId||'';
    const itemName=card.dataset.itemName||'';
    const itemBrand=card.dataset.itemBrand||'';
    const itemCategory=card.dataset.itemCategory||'';
    const itemListName=card.dataset.itemListName||'';
    const itemListId=card.dataset.itemListId||'';
    const itemPrice=toNumber(card.dataset.itemPrice);
    const itemCurrency=card.dataset.itemCurrency||'';
    const index=toNumber(card.dataset.itemIndex);
    if(!itemId||!itemName||!itemListName||!Number.isFinite(index))return null;
    const item={item_id:itemId,item_name:itemName,item_list_name:itemListName,index};
    if(itemListId)item.item_list_id=itemListId;
    if(itemBrand)item.item_brand=itemBrand;
    if(itemCategory)item.item_category=itemCategory;
    if(Number.isFinite(itemPrice))item.price=itemPrice;
    return {item,itemListName,itemListId,itemCurrency};
  };

  const pushEcommerce=(eventName,ecommerce)=>{
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({ecommerce:null});
    window.dataLayer.push({event:eventName,ecommerce});
  };

  document.addEventListener('click',event=>{
    const link=event.target.closest?.('a[href*="/products/"]');
    if(!link)return;
    const card=link.closest('[data-imperial-list-item]');
    if(!card)return;
    const data=itemFromCard(card);
    if(!data)return;
    const ecommerce={item_list_name:data.itemListName,items:[data.item]};
    if(data.itemListId)ecommerce.item_list_id=data.itemListId;
    if(data.itemCurrency)ecommerce.currency=data.itemCurrency;
    pushEcommerce('select_item',ecommerce);
  },true);

  const viewSignatures=window.__imperialViewItemListSignatures=window.__imperialViewItemListSignatures||new Set();
  const isSearchPage=()=>document.body?.dataset.template==='search'||location.pathname.replace(/\/$/,'')==='/search';

  const emitVisibleLists=()=>{
    if(isSearchPage())return;
    const cards=[...new Set([
      ...document.querySelectorAll('#product-grid [data-imperial-list-item]'),
      ...document.querySelectorAll('[data-imperial-list-container] [data-imperial-list-item]')
    ])];
    if(!cards.length)return;

    const groups=new Map();
    cards.forEach(card=>{
      const data=itemFromCard(card);
      if(!data)return;
      const key=data.itemListId||data.itemListName;
      if(!groups.has(key))groups.set(key,{itemListName:data.itemListName,itemListId:data.itemListId,itemCurrency:data.itemCurrency,items:[]});
      groups.get(key).items.push(data.item);
    });

    groups.forEach(group=>{
      if(!group.items.length)return;
      group.items.sort((a,b)=>a.index-b.index);
      const signature=`${location.pathname}${location.search}|${group.itemListId||group.itemListName}|${group.items.map(item=>item.item_id).join(',')}`;
      if(viewSignatures.has(signature))return;
      viewSignatures.add(signature);
      const ecommerce={item_list_name:group.itemListName,items:group.items};
      if(group.itemListId)ecommerce.item_list_id=group.itemListId;
      if(group.itemCurrency)ecommerce.currency=group.itemCurrency;
      pushEcommerce('view_item_list',ecommerce);
    });
  };

  /* MOBILE-PERF-V3-ANALYTICS — keep click attribution immediate, move list aggregation off first paint. */
  let timer=0;
  const scheduleViews=()=>{
    clearTimeout(timer);
    timer=setTimeout(emitVisibleLists,220);
  };

  const scheduleInitialViews=()=>{
    if('requestIdleCallback' in window){
      requestIdleCallback(emitVisibleLists,{timeout:1200});
    }else{
      setTimeout(emitVisibleLists,280);
    }
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scheduleInitialViews,{once:true});
  else scheduleInitialViews();

  const grid=document.getElementById('ProductGridContainer')||document.getElementById('product-grid');
  if(grid)new MutationObserver(scheduleViews).observe(grid,{childList:true,subtree:true});
})();
